import { useCallback } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import type { DateData } from "react-native-calendars";
import type { BasicDayProps } from "react-native-calendars/src/calendar/day/basic";
import { DAY_SIZE, Day } from "~/components/layout/calendar/Day";
import { MARKER_SIZE, Markers } from "~/components/layout/calendar/Markers";

import { Space } from "~/constants/sizing";

type DayItemProps = {
    date?: DateData;
    onPress?: (date: DateData) => void;
} & Omit<BasicDayProps, "date">;

export const DAY_GAP = Space.xs;
export const DAY_ITEM_HEIGHT = DAY_SIZE + DAY_GAP + MARKER_SIZE;

export const DayItem = ({ marking, date, state, onPress, onLongPress }: DayItemProps) => {
    const onDayPress = useCallback(() => onPress?.(date), [onPress, date]);
    const onDayLongPress = useCallback(() => onLongPress?.(date), [onLongPress, date]);

    return (
        <Pressable
            style={styles.container}
            disabled={state === "disabled"}
            onPress={onDayPress}
            onLongPress={onDayLongPress}
        >
            <Day
                day={date?.day}
                disabled={state === "disabled"}
                today={marking?.today}
                date={date?.dateString}
                period={Boolean(marking?.periods?.length)}
                periodColour={marking?.periods?.[0]?.color}
            />
            <View style={styles.markers}>
                <Markers dots={marking?.dots} />
            </View>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: "center",
        gap: DAY_GAP,
        height: DAY_ITEM_HEIGHT,
    },
    markers: {
        height: MARKER_SIZE,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
    },
});
